import { ResponseHeaderId } from '../models/events';
import { useResponseFoundHandler } from './hooks/useResponseFoundHandler';
import { CloudCoreFactory } from '../../factory';
import { useGadgetInstallationCompletionHandler } from './hooks/useGadgetInstallationCompletionHandler';
import { useGadgetInstallationProgressHandler } from './hooks/useGadgetInstallationProgressHandler';
import { useConnectionHandler } from './hooks/useConnectionHandler';
import { useDeviceDisconnection } from './hooks/useDeviceDisconnectionHandler';

export type HandlerPicker = (responseHeaderId: ResponseHeaderId) => Function;

export const CloudCoreResponseHandlers = () => {
    const cloudCoreClient = CloudCoreFactory.getInstance();
    const { handleOnConnectedDeviceFound } = useResponseFoundHandler();
    const { handleGadgetInstallationComplete } = useGadgetInstallationCompletionHandler();
    const { handleGadgetInstallationProgress } = useGadgetInstallationProgressHandler();
    const { handleOnDeviceDisconnect } = useDeviceDisconnection();
    const connectionHandlers = useConnectionHandler();

    const handlerPicker: HandlerPicker = (responseHeaderId: ResponseHeaderId) => {
        switch(responseHeaderId) {
            case "FetchDeviceListResponse":
                return handleOnConnectedDeviceFound;
            case "GadgetInstallationCompleted":
                return handleGadgetInstallationComplete;
            case "GadgetInstallationProgress":
                return handleGadgetInstallationProgress;
            case "DeviceDisconnectedEvent":
                return handleOnDeviceDisconnect;
            default:
                throw new Error();
        }
    }

    cloudCoreClient.attachConnectionHandler(connectionHandlers);
    cloudCoreClient.attachHandlers(handlerPicker);

    return null;
}